import InvoiceEditor from '@/pages/dashboard/finance/components/InvoiceEditor';

export default function NewQuotePage() {
  return <InvoiceEditor docType="quote" />;
}